/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';
export const SideBarMixin = {
  data: () => ({

  }),
  computed: {
    ...mapGetters('View', [
      'is_show_side_bar',
      'isMobile'
    ]),
  },
  methods: {
    ...mapActions('View', [
      'setShowSideBar'
    ]),
    getSideBarWidth() {
      let width = '0px';
      if (this.$route.matched.length > 2) {

        if (this.isMobile) {
          width = '100%';
        }
        else if (this.$route.matched[2].name === 'TaktPlanWaggon') {
          switch (this.$route.matched.length) {
            case 4:
              width = '330px';
              break;
            case 5:
              width = '651px';
              break;
            case 6:
              width = '972px';
              break;
            case 7:
              if (this.$route.matched[6].name === "TaktPlanWorkPackageMaterialStepMaterials") {
                width = '972px';
              } else {
                width = '1293px';
              }
              break;
          }
        }
      else if (this.$route.matched[2].name === 'TaktPlanBacklogs') {
        if (this.$route.matched[3] && this.$route.matched[3].name === 'TaktPlanAddWBWorkPackage') {
          // width = '661px';
          width = '391px';
        } else {
          switch (this.$route.matched.length) {
            case 3:
              width = '340px';
              break;
            case 4:
              // width = '661px';
              width = '410px';
              break;
            case 5:
              // width = '982px';
              width = '731px';
              break;
            case 6:
              // width = '1303px';
              width = '1052px';
              break;
            }
          }
        } else if (this.$route.matched[3] && this.$route.matched[3].name === 'HistProjectTaktPlanWaggon') {
          switch (this.$route.matched.length) {
            case 5:
              width = '330px';
              break;
            case 6:
              width = '651px';
              break;
            case 7:
              width = '972px';
              break;
            case 8:
              if (this.$route.matched[6].name === "HistoryProjectTaktPlanWorkPackageMaterialStepMaterials") {
                width = '972px';
              } else {
                width = '1293px';
              }
              break;
          }
        } else if (this.$route.matched[3] && this.$route.matched[3].name === 'HistProjectTaktPlanBacklogs') {
          switch (this.$route.matched.length) {
            case 4:
              width = '340px';
              break;
            case 5:
              // width = '661px';
              width = '391px';
              break;
            case 6:
              // width = '982px';
              width = '712px';
              break;
            case 7:
              // width = '1303px';
              width = '1033px';
              break;
          }
        }
    // else if (this.$route.matched[2] && this.$route.matched[2].name !== 'TaktPlanTrainDetails')) {
    //
    // }
    }
    return width;
    },
  }
};
